import MarkdownIt from "markdown-it";

const markdown = new MarkdownIt();

export default markdown;
